
import {defineComponent} from 'vue'
import {ReportChart, ReportChartOption} from '@/model/models'
import { Chart, registerables } from 'chart.js'
import { PieChart } from 'vue-chart-3'
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.register(...registerables)
Chart.register(ChartDataLabels)

export default defineComponent( {
  name: 'ReportPieChart',
  components: {
    PieChart
  },
  props: {
    chart: ReportChart,
    chartData: {}
  },
  computed: {
    chartOptions() {
      return {
        // For chart options see https://www.chartjs.org/docs
        responsive: true,
        plugins: {
          legend: {
            display: this.chart!.options.indexOf(ReportChartOption.Legend) >= 0,
            position: 'right'
          },
          tooltip: {
            padding: 10,
            boxPadding: 10
          },
          datalabels: {
            // For label options see https://chartjs-plugin-datalabels.netlify.app
            display: this.chart!.options.indexOf(ReportChartOption.Labels) >= 0,
            anchor: 'end',
            align: 'start',
            offset: 10,
            color: '#ffffff',
            font: {
              size: 13,
              weight: 'normal'
            }
          }
        }
      }
    }
  }
})
